module.exports = __webpack_public_path__ + "img/dog-friendly.2.eb42db0.jpg";